var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { Line } from 'react-chartjs-2';
import { withTheme } from 'styled-components';
import { tooltipConfig } from './chart-integration';
import { get, set } from '../utils/funcs';
var defaultConfig = {};

var lineChart = function lineChart(_a) {
  // Our default library configuration for line charts
  var _b = _a.config,
      config = _b === void 0 ? defaultConfig : _b,
      lines = _a.lines,
      theme = _a.theme;
  var libData = {
    datasets: [],
    labels: config.labels || []
  };
  var libOptions = {
    elements: {
      point: {
        radius: 0
      }
    },
    legend: config.legend || {
      display: false,
      position: 'right'
    },
    tooltips: Object.assign(tooltipConfig(theme), {
      callbacks: __assign(__assign({}, tooltipConfig(theme).callbacks), {
        label: function label(tooltipItem, data) {
          var index = get(tooltipItem, 'datasetIndex', -1);
          var label = get(data, "datasets[" + index + "].label", '');
          var yLabel = config.formatter ? config.formatter(tooltipItem.yLabel) : tooltipItem.yLabel;
          return label + ": " + yLabel;
        },
        title: function title(tooltipItem) {
          var xLabel = get(tooltipItem, '[0].xLabel');
          return config.titleFormatter ? config.titleFormatter(xLabel) : xLabel;
        }
      })
    }),
    scales: {
      xAxes: [],
      yAxes: []
    }
  }; // Transform our data API to the library's API

  lines.forEach(function (line, i) {
    // Defaults per line axis
    libOptions.scales.xAxes[i] = {
      type: line.xDataType || 'linear',
      ticks: {
        maxTicksLimit: line.grids || 4,
        maxRotation: line.rotateLabels ? 90 : 0,
        minRotation: line.rotateLabels ? 90 : 0,
        padding: 16,
        minor: {
          fontColor: theme.textPrimary
        }
      },
      gridLines: {
        display: false,
        drawBorder: false
      },
      scaleLabel: {
        display: config.showXAxisLabel || false,
        labelString: config.xAxisLabel
      }
    };
    libOptions.scales.yAxes[i] = {
      type: line.yDataType || 'linear',
      ticks: {
        padding: 16,
        callback: function callback(label) {
          return config.formatter ? config.formatter(label) : label;
        },
        minor: {
          fontColor: theme.textPrimary
        }
      },
      gridLines: {
        display: false,
        drawBorder: false
      },
      scaleLabel: {
        display: config.showYAxisLabel || false,
        labelString: config.yAxisLabel
      }
    }; // Calculate better mins and maxes for the lines

    var yMax = (config.max ? config.max : Math.max.apply(Math, line.data)) * 1.05;
    var yMin = (config.min ? config.min : Math.min.apply(Math, line.data)) * 0.95;
    set(libOptions, "scales.yAxes[" + i + "].ticks['suggestedMax']", yMax);
    set(libOptions, "scales.yAxes[" + i + "].ticks['suggestedMin']", yMin);
    libData.datasets[i] = {
      backgroundColor: theme.themeName === 'dark' ? line.fill ? theme.mix(theme.colorLevel(theme[line.brand], -11), '#000000', 35) : 'rgba(0,0,0,0)' : line.fill ? theme.colorLevel(theme[line.brand], -11) : 'rgba(0,0,0,0)',
      borderColor: theme[line.brand] || theme.primary,
      borderWidth: 2,
      cubicInterpolationMode: 'monotone',
      data: line.data,
      label: line.title
    };
  }); // If we don't want multiple axes, hard overwrite with only one axis

  if (!config.multiAxis) {
    set(libOptions, 'scales.xAxes', [get(libOptions, 'scales.xAxes[0]')]);
    set(libOptions, 'scales.yAxes', [get(libOptions, 'scales.yAxes[0]')]);
  } // Render the library's chart


  return React.createElement(Line, {
    data: libData,
    options: libOptions
  });
};

export var ChartLine = withTheme(lineChart);